// pc
    function customVideoPlay(element){
        var videoId = $(element).find('.custom-autoPlay-videoPlayer').attr('id');
        videoPlayOrPause(videoId,"customVideoPlayButton");
    }

    function videoPlayMobile(element){
        var videoId = $(element).find('.custom-autoPlay-videoPlayer-mobile').attr('id');
        videoPlayOrPause(videoId,"customVideoPlayButtonMobile");
    }

    function videoPlayOrPause(id,buttonId){
    var video = document.getElementById(id);
    var videoButton = $("#"+buttonId);

    if (video.paused){
        // 暂停状态
        videoButton.fadeOut();
        video.play();
        video.controls = true;
    }else {
        // 播放状态
        videoButton.fadeIn();
        video.pause();
        video.controls = false;
    }
}